import { ELEMENT_PARAGRAPH } from '@udecode/plate';
export const EMPTY_VALUE = {
    type: ELEMENT_PARAGRAPH,
    url: undefined,
    children: [{ text: '' }],
};
//# sourceMappingURL=constants.js.map